import type { FetchModelResponse } from '@cian/http-api';
import { UnknownError } from '@cian/peperrors/shared';

import { TDeleteOfferFromFavoritesResponse } from '../../../../repositories/favorites/v1/delete-offer-from-favorites';
import { IDefaultSuccessResponse } from '../../../../repositories/favorites/entities/delete_user_favorites/DefaultSuccessResponse';

export function assertUnknownError(
  response: TDeleteOfferFromFavoritesResponse,
): asserts response is FetchModelResponse<200, 'json', IDefaultSuccessResponse> {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new UnknownError({
    domain: 'src/shared/services/favorite/deleteFavorite/deleteFavoriteRequest.ts',
    message: message || '',
    details: {
      errors: JSON.stringify(errors),
    },
  });
}
